// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".max-price-label[data-v-d7b47ad4]{padding:8px 16px 8px 8px;background:#eef4ff;border:1px solid #5794ff;border-radius:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:8px}.max-price-label[data-v-d7b47ad4] .icon{width:16px;height:16px}.max-price-label .text[data-v-d7b47ad4]{margin-left:8px!important;font-weight:400;font-size:14px;line-height:16px}", ""]);
// Exports
module.exports = exports;
